import React, { FunctionComponent, createContext, useContext, useState } from 'react'
import { omit } from 'lodash'

export type LinkedLesson = {
  lessonID: string
  title: string
  category: string
}

export type Context = {
  lesson: LinkedLesson | undefined
  removeLesson: () => void
  setLesson: (lesson: LinkedLesson) => void
}

const useLesson = (feedID: string) => {
  const [lessons, setLessons] = useState<Record<string, LinkedLesson>>({})
  const removeLesson = () => setLessons(omit({ ...lessons }, feedID))
  const setLesson = (lesson: LinkedLesson) =>
    setLessons({
      ...lessons,
      [feedID]: lesson,
    })
  return {
    lesson: lessons[feedID],
    removeLesson,
    setLesson,
  }
}

const MentionLessonContext = createContext<Context>({} as ReturnType<typeof useLesson>)

type Props = {
  feedID: string
}

export const MentionLessonContextProvider: FunctionComponent<Props> = ({ children, feedID }) => {
  const lessonContext = useLesson(feedID)
  return <MentionLessonContext.Provider value={lessonContext}>{children}</MentionLessonContext.Provider>
}

export const useMentionLesson = () => useContext(MentionLessonContext)
